<div
  class="unauthorized-container flex flex-wrap md:flex-row flex-col-reverse p-10 h-full font-inter md:my-1 md:w-10/12 2xl:w-7/12 w-11/12 mx-auto justify-center items-height"
>
  <div
    class="text-container flex flex-col md:w-1/2 w-full justify-center md:items-start items-center md:text-left text-center"
  >
    <h5 class="font-inter md:text-2xl text-xl text-black-700 not-found-text">
      <b
        >Oops! <br />
        Looks like we’re having trouble <br />
        loading the right form...</b
      >
    </h5>
    <p
      class="font-inter font-500 text-sm font-normal text-black mt-2 not-found-text-inner"
    >
      <a [href]="'mailto:support@xilo.io?subject=Inactive Account - Billing'">
        Please contact support.
      </a>
    </p>

  </div>
  <div class="lemonade-img flex items-center justify-center md:w-1/2 mx-auto w-full">
    <div class="flex justify-center md:w-auto h-auto">
      <svg
        class="md:h-96 md:w-500 h-52 w-52"
        viewBox="0 0 504 507"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        version="1.2"
        baseProfile="tiny-ps"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 377 335"
        width="377"
        height="335"
      >
        <style>
          tspan {
            white-space: pre;
          }
          .shp0 {
            opacity: 0.18;
            fill: #6e71ff;
          }
          .shp1 {
            opacity: 0.902;
            fill: #8487ff;
          }
          .shp2 {
            opacity: 0.902;
            fill: #6e71ff;
          }
          .shp3 {
            opacity: 0.169;
            fill: #6e71ff;
          }
          .shp4 {
            fill: #ffffff;
          }
          .shp5 {
            opacity: 0.22;
            fill: #6e71ff;
          }
          .shp6 {
            fill: #d0d0ff;
          }
          .shp7 {
            fill: #6e71ff;
          }
          .shp8 {
            opacity: 0.42;
            fill: #ffffff;
          }
          .shp9 {
            fill: #473f47;
          }
          .shp10 {
            opacity: 0.451;
            fill: #6e71ff;
          }
          .shp11 {
            opacity: 0.271;
            fill: #ffffff;
          }
          .shp12 {
            opacity: 0.529;
            fill: #ffffff;
          }
          .shp13 {
            opacity: 0.902;
            fill: #afb1ff;
          }
          .shp14 {
            fill: #7071bf;
          }
          .shp15 {
            fill: #7f80e1;
          }
          .shp16 {
            fill: #bbbcff;
          }
        </style>
        <path
          id="Layer"
          fill-rule="evenodd"
          class="shp0"
          d="M68.81 13.59C114.26 -15.13 169.67 11.31 221.89 24.43C273.51 37.4 333.94 40.55 360.31 86.84C388.41 136.15 376.93 198.66 349.35 248.12C323.28 294.86 275.86 326.03 222.84 333.34C174.06 340.07 130.48 313.68 91.31 283.71C49.56 251.76 5.66 216.17 1.3 163.82C-3.5 106.19 20.01 44.43 68.81 13.59Z"
        />
        <path
          id="Layer"
          fill-rule="evenodd"
          class="shp1"
          d="M277.62 200.17C290.08 199.99 301.71 200.83 311.37 201.62C320.52 202.37 326.45 203.39 330.33 204.5C334.27 205.62 337.02 206.82 333.61 207.96C330.14 209.12 322.69 210.23 311.59 210.75C301.12 211.25 289.23 210.56 277.62 210.6C265.31 210.65 253.22 211.46 241.81 211C229.42 210.51 220.51 209.37 215.73 208.14C210.8 206.88 208.13 205.35 215.22 204.19C222.08 203.06 239.12 203.21 250.29 202.49C260.61 201.82 265.39 200.34 277.62 200.17Z"
        />
        <path
          id="Layer"
          class="shp2"
          d="M316.09 215.98C316.09 216.01 316.09 216.04 316.09 216.07C315.8 217.63 308.21 218.87 298.88 218.87C290.02 218.87 282.73 217.75 281.77 216.32C281.7 216.22 281.67 216.11 281.66 215.99C281.66 215.88 281.7 215.76 281.77 215.67C281.8 215.62 281.84 215.58 281.88 215.54C283.18 214.17 290.3 213.11 298.88 213.11C308.2 213.11 315.79 214.35 316.09 215.9C316.09 215.93 316.09 215.95 316.09 215.98Z"
        />
        <path
          id="Layer"
          class="shp3"
          d="M48 202.5C48 196.64 101.46 191.89 167.41 191.89C233.36 191.89 286.82 196.64 286.82 202.5C286.82 208.36 233.36 213.11 167.41 213.11C101.46 213.11 48 208.36 48 202.5Z"
        />
        <path
          id="Layer"
          class="shp2"
          d="M281.66 219.7C281.66 219.71 281.66 219.73 281.66 219.75C281.51 220.52 277.51 221.14 272.59 221.14C267.92 221.14 264.08 220.58 263.57 219.87C263.54 219.82 263.52 219.76 263.51 219.7C263.52 219.65 263.54 219.59 263.57 219.54C263.59 219.52 263.61 219.5 263.63 219.48C264.31 218.79 268.06 218.26 272.59 218.26C277.5 218.26 281.5 218.88 281.66 219.66C281.66 219.67 281.66 219.69 281.66 219.7Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M237.17 189.55C236.98 188.94 236.93 188.31 237.02 187.68C237.18 187.1 237.46 186.57 237.84 186.12C240.15 183.1 242.95 180.48 246.12 178.36C246.4 178.15 246.71 177.99 247.04 177.88C247.51 177.78 248 177.78 248.47 177.88C252.01 178.35 255.49 179.17 258.86 180.31C259.32 180.43 259.75 180.66 260.09 180.98C260.44 181.42 260.64 181.96 260.69 182.52C261.46 187.04 262.06 191.57 262.46 196.13C262.56 196.49 262.52 196.87 262.36 197.2C262.2 197.53 261.92 197.79 261.58 197.94L253.94 202.89C253.02 203.62 251.9 204.05 250.73 204.11C250.23 204.07 249.74 203.95 249.27 203.76C247.61 203.19 246 202.52 244.41 201.8C243.02 201.15 240.86 200.46 239.77 199.35C238.81 198.39 238.77 196.64 238.48 195.36L237.17 189.55Z"
        />
        <path
          id="Layer"
          class="shp5"
          d="M241.11 188.68L239.04 187.99C238.97 187.98 238.91 187.95 238.86 187.89C238.84 187.86 238.83 187.83 238.82 187.8C238.81 187.76 238.81 187.72 238.82 187.69C238.88 186.49 239.89 185.61 240.8 184.84C242.65 183.27 244.39 181.59 246.04 179.81C246.42 179.33 246.91 178.94 247.48 178.68C247.91 178.55 248.36 178.51 248.81 178.56C252.07 178.76 255.2 179.95 257.76 181.97C255.47 185.1 252.73 187.87 249.62 190.2C249.29 190.48 248.92 190.7 248.52 190.84C247.9 190.98 247.26 190.94 246.67 190.72C244.32 190.01 242.2 188.39 239.71 188.54"
        />
        <path
          id="Layer"
          class="shp4"
          d="M199.63 133.87C200.17 128.16 201.17 122.51 202.61 116.95C204.35 110.71 206.53 107.02 208.9 107.02C212.39 107.02 215.49 115.11 217.37 127.52L215.48 128.19C213.92 118.15 211.56 111.75 208.9 111.75C206.96 111.75 205.18 115.15 203.75 120.89L203.75 121.07C202.82 125.04 202.13 129.07 201.69 133.12L199.63 133.87Z"
        />
        <path
          id="Layer"
          class="shp0"
          d="M208.92 201.48C206.99 201.48 205.2 198.08 203.77 192.34L203.77 192.17C201.76 183.96 200.42 171.08 200.42 156.6C200.42 142.12 201.71 129.24 203.77 121.04L203.77 120.87C205.2 115.13 206.99 111.72 208.92 111.72C213.63 111.72 217.43 131.82 217.43 156.6C217.43 181.38 213.63 201.48 208.92 201.48Z"
        />
        <path
          id="Layer"
          class="shp0"
          d="M203.72 192.16C201.71 183.95 200.37 171.08 200.37 156.6C200.37 142.11 201.67 129.24 203.72 121.04C205.75 129.24 207.07 142.12 207.07 156.6C207.07 171.07 205.75 183.92 203.72 192.16Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M208.92 204.68C206.55 204.68 204.37 200.99 202.63 194.75C200.14 185.83 198.53 171.73 198.53 155.86C198.53 151.07 198.67 146.46 198.94 142.09L200.92 141.35C200.59 146.12 200.42 151.28 200.42 156.61C200.42 171.09 201.71 183.97 203.77 192.17L203.77 192.35C205.2 198.09 206.99 201.48 208.92 201.48C210.2 201.48 211.41 200.01 212.5 197.35C213.49 194.74 214.24 192.05 214.74 189.31C215.04 187.83 215.32 186.25 215.57 184.56C216.64 177.04 217.25 169.46 217.38 161.86C217.38 160.14 217.43 158.38 217.43 156.61C217.43 149 217.07 141.83 216.44 135.55L218.3 134.85C219 141.82 219.34 148.81 219.32 155.81C219.32 157.54 219.32 159.23 219.26 160.91C219.13 168.87 218.48 176.82 217.31 184.69L217.15 185.64C216.51 190.2 215.38 194.68 213.8 199.01C212.33 202.68 210.68 204.68 208.92 204.68Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M179.14 204.68L81.93 204.68C76.19 204.68 71.53 182.82 71.53 155.85C71.53 128.88 76.19 107 81.93 107L179.14 107C182.72 107 186.16 108.41 188.69 110.91C191.22 113.41 192.64 116.8 192.64 120.34L192.64 191.35C192.64 193.1 192.29 194.83 191.62 196.45C190.94 198.07 189.94 199.54 188.69 200.78C187.44 202.01 185.95 203 184.31 203.67C182.67 204.34 180.91 204.68 179.14 204.68Z"
        />
        <path
          id="Layer"
          class="shp6"
          d="M171.53 111.72C180.94 111.72 184.08 119.58 184.47 123.51L184.47 186.58C184.47 188.35 184.47 200.14 170.94 200.14L85.65 200.14C72.71 200.14 76.24 111.13 85.65 111.13C92.12 111.13 159.76 111.72 171.53 111.72Z"
        />
        <path
          id="Layer"
          class="shp7"
          d="M191.97 183.88L194.05 183.53L210.39 180.77L212.35 180.44L242.79 175.31L273.88 201.34L277.21 204.13L277.4 204.3L271.77 209.79L270.73 210.8L265.52 206.26L262.54 203.67L238.7 182.94L215.22 187.26L213.25 187.63L198.91 190.27L198.81 190.29L196.66 190.64L139.84 200.14L118.43 199.69L119.42 196.11L191.97 183.88Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M189.03 184.82L180.41 193.33L174.7 194.37L183.29 185.8L189.03 184.82Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M151.56 191.02L142.94 199.53L137.23 200.57L145.81 192L151.56 191.02Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M135.03 193.62L126.4 202.13L120.7 203.18L129.28 194.6L135.03 193.62Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M176.33 186.8L167.7 195.31L161.99 196.36L170.58 187.78L176.33 186.8Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M164.65 188.63L156.02 197.13L150.3 198.18L158.9 189.61L164.65 188.63Z"
        />
        <path
          id="Layer"
          class="shp8"
          d="M239.55 179.58L273.16 206.58L271.77 209.79L270.74 210.8L238.7 182.94L198.91 190.27L196.42 186.89L239.55 179.58Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M218.08 179.73L209.46 188.21L203.74 189.27L212.33 180.7L218.08 179.73Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M207.29 181.66L198.67 190.16L192.97 191.21L201.55 182.64L207.29 181.66Z"
        />
        <path
          id="Layer"
          class="shp9"
          d="M273.15 206.58C275 204.81 276.96 203.85 277.53 204.44C278.09 205.02 277.05 206.93 275.2 208.7C273.35 210.47 271.39 211.43 270.82 210.84C270.25 210.26 271.3 208.35 273.15 206.58Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M274.45 201.85L266.29 206.93L262.54 203.66L271.12 199.06L274.45 201.85Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M267.46 195.91L259.15 200.72L254.72 196.86L263.29 192.48L267.46 195.91Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M258.32 188.31L250.27 192.97L246.8 189.93L254.76 185.33L258.32 188.31Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M251.16 182.08L242.57 186.2L239.8 183.8L247.84 179.29"
        />
        <path
          id="Layer"
          class="shp4"
          d="M239.64 175.84L231.02 184.35L225.31 185.4L233.9 176.83L239.64 175.84Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M228.86 177.79L220.24 186.28L214.53 187.33L223.12 178.77L228.86 177.79Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M165.6 178.73C166.22 178.73 166.84 178.87 167.4 179.14C167.89 179.46 168.31 179.88 168.63 180.38C170.82 183.4 172.5 186.76 173.62 190.32C173.73 190.64 173.8 190.97 173.82 191.31C173.78 191.78 173.65 192.24 173.44 192.65C172.02 195.81 170.3 198.81 168.31 201.63C168.07 202.02 167.75 202.35 167.35 202.59C166.84 202.78 166.28 202.81 165.75 202.69C161.31 202.11 156.91 201.34 152.52 200.4C152.16 200.39 151.82 200.25 151.55 200C151.29 199.75 151.12 199.42 151.08 199.06L148.57 190.51C148.14 189.45 148.05 188.29 148.31 187.18C148.49 186.72 148.74 186.3 149.04 185.92C150.03 184.55 151.09 183.23 152.21 181.97C153.2 180.85 154.44 179.04 155.76 178.34C156.91 177.72 158.56 178.18 159.84 178.29L165.6 178.73Z"
        />
        <path
          id="Layer"
          class="shp5"
          d="M165.26 182.62L166.48 180.88C166.51 180.82 166.55 180.78 166.61 180.75C166.68 180.73 166.76 180.74 166.82 180.77C167.91 181.17 168.47 182.37 168.94 183.44C169.9 185.62 170.99 187.73 172.2 189.77C172.56 190.27 172.79 190.85 172.88 191.46C172.88 191.89 172.8 192.31 172.64 192.71C171.55 195.69 169.59 198.26 167 200.06C164.71 197.03 162.87 193.68 161.54 190.11C161.37 189.73 161.28 189.32 161.25 188.9C161.29 188.29 161.5 187.7 161.87 187.21C163.19 185.26 165.28 183.74 165.84 181.4"
        />
        <path
          id="Layer"
          class="shp4"
          d="M208.92 204.68L196.34 204.68C196.34 204.68 196.26 204.68 196.13 204.68C195.99 204.68 195.98 204.68 195.88 204.68C195.78 204.68 195.66 204.63 195.51 204.58C193.28 203.77 191.23 199.6 189.61 193.14C187.38 184.2 185.94 170.83 185.94 155.9C185.94 140.98 187.37 127.6 189.61 118.64C191.22 112.22 193.25 108.06 195.49 107.22C195.61 107.17 195.75 107.13 195.88 107.11C195.97 107.11 196.06 107.11 196.13 107.11C196.19 107.11 196.34 107.11 196.34 107.11L208.92 107.11C205.57 108.66 203.49 114.06 202.58 116.91L202.58 117.06C200.09 125.97 198.48 140.08 198.48 155.96C198.48 171.83 200.09 185.93 202.58 194.86L202.58 195C203.5 197.75 205.6 203.14 208.92 204.68Z"
        />
        <path
          id="Layer"
          class="shp10"
          d="M131.35 116.03C131.01 116.34 130.81 116.77 130.79 117.23L130.79 115.86L131.35 116.03Z"
        />
        <path
          id="Layer"
          class="shp10"
          d="M219.96 116.98L219.96 117.23C219.97 117.15 219.97 117.07 219.96 116.99L219.96 116.98Z"
        />
        <path
          id="Layer"
          class="shp11"
          d="M189.28 143.22C189.28 143.22 183.32 131.69 176.62 131.27C169.91 130.85 76.24 131.27 76.24 131.27L77.9 118.81L176.92 118.81C176.92 118.81 184.46 117.83 190.63 128.28L189.28 143.22Z"
        />
        <path
          id="Layer"
          class="shp12"
          d="M191.77 181.87C192.72 181.81 193.35 186.09 193.61 187.21C193.83 188.58 193.83 189.99 193.61 191.36C193.38 193.27 192.97 195.45 191.33 196.38C191.09 196.52 190.83 196.62 190.55 196.65C190.28 196.68 190 196.65 189.73 196.57C189.35 196.39 189.03 196.11 188.8 195.75C188.01 194.67 187.6 193.35 187.63 192C187.74 190.65 188.07 189.32 188.6 188.08C189.08 186.85 190.04 181.97 191.77 181.87Z"
        />
        <path
          id="Layer"
          class="shp13"
          d="M171.25 200.14L85.12 200.14C84.13 200.14 81.55 197.31 79.18 186C84.52 194.25 110.65 191.82 117.19 190.71C126.64 189.12 142.14 188.94 155.81 190.71C166.74 192.13 180.16 189.34 185.51 187.76C185.11 191.89 181.71 200.14 171.25 200.14Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M201.49 178.45C201.92 183.8 202.96 188.67 203.69 191.95L202.59 193L199.86 194.86L198.09 179.53C199.22 177.95 201.49 175.53 201.49 178.45Z"
        />
        <path
          id="Layer"
          class="shp0"
          d="M172.58 200.47L163.19 200.47C167.26 199.69 170.53 180 170.53 155.82C170.53 133.53 167.75 115.07 164.13 111.69C164.03 111.59 163.91 111.49 163.79 111.41L172.58 111.41C174.16 111.41 175.71 111.72 177.16 112.32C178.62 112.91 179.93 113.78 181.04 114.88C182.15 115.98 183.03 117.29 183.63 118.72C184.23 120.16 184.53 121.7 184.53 123.25L184.53 188.72C184.51 191.84 183.25 194.83 181.01 197.03C178.77 199.23 175.74 200.47 172.58 200.47Z"
        />
        <path
          id="Layer"
          class="shp4"
          d="M182.93 194.63C184.56 190.74 184.66 186.44 184.5 184.78L187.11 181.73L191.19 181.96L191.19 194.63C187.76 196.25 181.3 198.51 182.93 194.63Z"
        />
        <path
          id="Layer"
          class="shp14"
          d="M236.68 230.5C236.85 225.92 242.13 227.79 243.26 223.25C246.14 223.32 259.29 223.75 259.29 224.91C259.29 228.87 259.42 229.78 253.89 232.58C248.35 235.38 237.13 237.25 229.3 237.25C221.48 237.25 211.24 235.9 205.7 233.1C200.17 230.3 200.29 228.87 200.29 224.91C200.29 224.63 200.79 224.56 200.79 224.28C201.05 226.67 202.8 224.3 205.21 226.36C207.62 228.41 211.03 228.2 215.04 229.47C219.06 230.73 221.64 230.64 226.35 230.83C231.06 231.02 232.32 231.44 236.68 230.5Z"
        />
        <path
          id="Layer"
          class="shp7"
          d="M229.78 216.25C238.67 216.25 244.05 216.73 248.37 218.25C248.08 218.46 247.58 219 247.29 219.25C245.29 221.25 244.79 221.75 243.79 222.75C244 222.75 245.1 223.2 246.29 223.25C250.62 223.38 259.29 224.19 259.29 224.76C259.28 226.29 257.83 227.8 255.08 229.11C252.34 230.43 248.41 231.51 243.71 232.23C242.92 232.36 242.12 232.47 241.28 232.57C236.92 233.1 232.18 233.33 227.46 233.22C222.75 233.11 218.18 232.68 214.17 231.96C210.15 231.24 206.79 230.25 204.38 229.08C201.96 227.9 200.56 226.58 200.29 225.22C200.29 225.06 200.29 224.9 200.29 224.74C200.31 222.48 203.43 220.33 208.95 218.74C214.48 217.14 221.97 216.25 229.78 216.25Z"
        />
        <path
          id="Layer"
          class="shp12"
          d="M252.75 224.4C252.97 224.48 253.07 224.57 253.02 224.65C251.96 226.75 247.66 227.58 245.06 227.9C244.83 227.93 244.57 227.94 244.3 227.95C244.03 227.95 243.76 227.94 243.51 227.92C243.26 227.9 243.04 227.87 242.85 227.82C242.67 227.78 242.53 227.73 242.45 227.68L235.83 223.95C235.73 223.89 235.71 223.81 235.79 223.75C235.87 223.68 236.04 223.61 236.27 223.56C236.51 223.51 236.8 223.48 237.12 223.46C237.44 223.45 238.96 223.35 239.27 223.38L251.78 224.24C252.18 224.27 252.52 224.32 252.75 224.4Z"
        />
        <path
          id="Layer"
          class="shp12"
          d="M223.37 229.76C222.4 229.67 222.23 228.47 223.11 228.07C226.42 226.57 231.54 224.3 232.35 224.25C233.15 224.2 236.33 226.26 238.45 227.71C239.19 228.21 238.93 229.32 238.05 229.44C231.75 230.27 226.49 230.05 223.37 229.76Z"
        />
        <path
          id="Layer"
          class="shp12"
          d="M239.35 218.76C239.88 218.8 239.98 219.51 239.49 219.69C236.89 220.67 232.62 222.23 231.79 222.28C230.93 222.33 228.54 220.51 227.18 219.41C226.82 219.13 227.02 218.57 227.47 218.56C231.45 218.44 235.5 218.51 239.35 218.76Z"
        />
        <path
          id="Layer"
          class="shp12"
          d="M205.39 224.11C205.56 223.75 205.99 223.65 206.38 223.64L228.37 223.3C228.94 223.29 229.08 224.09 228.54 224.27L217.95 227.84C216.75 228.24 215.46 228.36 214.21 228.14C205.43 226.63 205 224.91 205.39 224.11Z"
        />
        <path
          id="Layer"
          class="shp12"
          d="M222.36 218.87C223.34 218.8 224.31 219.03 225.16 219.53L228.2 221.31C228.64 221.57 228.46 222.25 227.95 222.25L209.35 222.24C208.02 222.24 207.61 221.27 208.87 220.86C212.42 219.7 219.32 219.09 222.36 218.87Z"
        />
        <path
          id="Layer"
          class="shp12"
          d="M247.29 219.25L245.54 221L243.79 222.75L236.84 222.36C236.49 222.34 236.45 221.85 236.79 221.77L247.29 219.25Z"
        />
        <path
          id="Layer"
          class="shp15"
          d="M315.31 157.67C321.65 164.01 328.07 180.63 314.29 194.41C300.51 208.19 283.37 202.29 277.03 195.94C270.69 189.6 274.12 175.89 284.69 165.32C295.26 154.75 308.97 151.33 315.31 157.67Z"
        />
        <path
          id="Layer"
          class="shp7"
          d="M307.65 188.29C297.07 198.87 283.38 202.29 277.03 195.94C270.68 189.59 274.1 175.91 284.69 165.32C295.27 154.74 308.96 151.32 315.31 157.67C321.66 164.02 318.24 177.71 307.65 188.29Z"
        />
        <path
          id="Layer"
          class="shp16"
          d="M293.85 179.49C294.48 178.75 295.7 179.26 295.6 180.24L294.47 191.76C294.43 192.12 294.2 192.44 293.87 192.57C289.91 194.17 286.25 194.51 283.45 193.54C282.84 193.33 282.7 192.59 283.11 192.1L293.85 179.49Z"
        />
        <path
          id="Layer"
          class="shp16"
          d="M291.63 177.18C292.61 177 293.23 178.18 292.52 178.88L281.06 190.15C280.62 190.58 279.9 190.51 279.62 189.96C278.31 187.39 278.27 183.9 279.51 180.05C279.62 179.71 279.91 179.46 280.26 179.39L291.63 177.18Z"
        />
        <path
          id="Layer"
          class="shp16"
          d="M294.79 174.34C294.84 174.96 294.32 175.48 293.7 175.43L283.67 174.56C282.93 174.5 282.52 173.68 282.94 173.06C285.43 169.42 288.73 166.08 292.36 163.53C292.97 163.1 293.8 163.51 293.87 164.25L294.79 174.34Z"
        />
        <path
          id="Layer"
          class="shp16"
          d="M298.44 172.95C297.75 173.66 296.56 173.05 296.74 172.08L298.71 160.96C298.77 160.61 299.02 160.31 299.36 160.2C303.2 158.93 306.69 158.95 309.27 160.22C309.83 160.49 309.9 161.22 309.46 161.66L298.44 172.95Z"
        />
        <path
          id="Layer"
          class="shp16"
          d="M300.03 176.2C299.05 176.38 298.44 175.17 299.17 174.49L311.09 163.39C311.56 162.95 312.32 163.06 312.54 163.67C312.99 164.84 313.19 166.18 313.14 167.67C313.07 169.51 312.63 171.52 311.81 173.62C311.69 173.94 311.41 174.16 311.07 174.22L300.03 176.2Z"
        />
        <path
          id="Layer"
          class="shp16"
          d="M296.82 178.54C296.75 177.91 297.28 177.37 297.92 177.44L308.21 178.53C308.95 178.61 309.34 179.43 308.92 180.04C307.67 181.85 306.21 183.6 304.6 185.22C302.98 186.84 301.24 188.31 299.43 189.58C298.82 190 298 189.61 297.92 188.87L296.82 178.54Z"
        />
      </svg>
    </div>
  </div>
</div>
